<template>
	<div>
		<c-dialog ref="dialog" title="打印模板管理" enable-flex width="1000" height="600" button-name="关闭" :cancel-button="false">
			<c-tab-list ref="tabList" :tabs="tabList" :immediate="false" type="border-tab" @change="tabHandle"></c-tab-list>
			<!--内置打印-->
			<div v-if="currentTab==1" key="1" class="flex-grow flex">
				<div class="flex-column flex-grow">
					<m-operate style="border: none; background: none;">
						<c-button v-lock="lock(print)" color="main" prepend-icon="tf-add" @click="editHandle()">添加模板</c-button>
					</m-operate>
					<c-table height="grow" :data="templateList" @rowClick="clickHandle">
						<c-table-column
							label="模板名称"
							name="template_name"
							width="250"
						>
							<template #default="{data}">
								<span v-if="data.is_sys_template==2" style="color: #55a532">【系统】</span>
								<span v-else style="color: #0D6EFE">【自定义】</span>
								{{data.template_name}}
							</template>
						</c-table-column>

						<c-table-column
							label="纸张大小"
							width="120"
						>
							<template #default="{data}">
								<span>{{data.width}}mm x {{data.height}}mm</span>
							</template>
						</c-table-column>

						<c-table-column
							label="创建时间"
							name="create_date"
							width="120"
						></c-table-column>

						<c-table-column
							label="操作"
							type="button"
							width="160"
						>
							<template #default="{data}">
								<c-table-button v-if="data.saas_id != 0" icon="tf-edit" @click="editHandle(data)">编辑</c-table-button>
								<c-table-button v-lock="lock(print)" icon="tf-copy" @click="editHandle(data, true)">复制</c-table-button>
								<c-table-button v-if="data.saas_id != 0" icon="tf-trash" @click="deleteHandle(data)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</div>
				<div class="preview">
					<p class="preview-title">模板效果预览</p>
					<div v-html="htmlTempContent" class="preview-content"></div>
				</div>
			</div>

			<!--Excel打印-->
			<div v-if="currentTab == 2" key="2" class="flex-grow flex-column">
				<div class="flex-column flex-grow">
					<div class="import-steps">
						<p>· 可通过下载系统模板，根据需要自行调整Excel模板格式；
							<span v-if="printReadmeUrl">Excel模板参数详见<c-link @click="window.open(printReadmeUrl)">《打印模板参数》</c-link></span>
						</p>
						<p>· 最多存在50个自定义Excel模板，上传的模板文件大小不超过1MB，支持格式为 .xlsx</p>
					</div>
					<m-operate>
						<c-button v-lock="lock(print)" color="main" prepend-icon="tf-add" @click="uploadHandle">上传模板</c-button>
					</m-operate>
					<c-table height="grow" :data="templateList">
						<c-table-column
							label="模板名称"
							name="template_name"
							width="350"
						>
							<template #default="{data}">
								<span v-if="data.is_sys_template==2" style="color: #55a532">【系统】</span>
								<span v-else style="color: #0D6EFE">【自定义】</span>
								{{data.template_name}}
							</template>
						</c-table-column>

						<c-table-column
							label="纸张大小"
							width="150"
						>
							<template #default="{data}">
								<span v-if="data.width && data.height">
									<c-state dict="paperSize" :value="`${data.width}x${data.height}`"></c-state>
									<span v-if="!$store.state.dictData.paperSize[`${data.width}x${data.height}`]">{{data.width}}cm x {{data.height}}cm</span>
								</span>
								<span v-else>-</span>
							</template>
						</c-table-column>

						<c-table-column
							label="创建时间"
							name="create_date"
							width="140"
						></c-table-column>

						<c-table-column
							label="操作"
							type="button"
							width="120"
						>
							<template #default="{data}">
								<c-table-button @click="downloadHandle(data)">下载</c-table-button>
								<c-table-button v-if="data.saas_id != 0" @click="paperHandle(data)">编辑</c-table-button>
								<c-table-button v-if="data.saas_id != 0" icon="tf-trash" @click="deleteHandle(data)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</div>
			</div>

			<!--Excel导出-->
			<div v-if="currentTab == 3" key="3" class="flex-grow flex-column">
				<div class="flex-column flex-grow">
					<div class="import-steps">
						<p>· 可通过下载系统模板，根据需要自行调整Excel模板格式；
							<span v-if="exportReadmeUrl">Excel中所支持的参数信息见<c-link @click="window.open(exportReadmeUrl)">《导出模板参数》</c-link></span>
						</p>
						<p>· 最多存在50个自定义Excel模板，上传的模板文件大小不超过1MB，支持格式为 .xlsx</p>
					</div>
					<m-operate>
						<c-button v-lock="lock(this.export)" color="main" prepend-icon="tf-add" @click="uploadHandle">上传模板</c-button>
					</m-operate>
					<c-table height="grow" :data="templateList">
						<c-table-column
							label="模板名称"
							name="template_name"
							width="350"
						>
							<template #default="{data}">
								<span v-if="data.is_sys_template==2" style="color: #55a532">【系统】</span>
								<span v-else style="color: #0D6EFE">【自定义】</span>
								{{data.template_name}}
							</template>
						</c-table-column>

						<c-table-column
							label="创建时间"
							name="create_date"
							width="140"
						></c-table-column>

						<c-table-column
							label="操作"
							type="button"
							width="120"
						>
							<template #default="{data}">
								<c-table-button @click="downloadHandle(data)">下载</c-table-button>
								<c-table-button v-if="data.saas_id != 0" icon="tf-trash" @click="deleteHandle(data)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</div>
			</div>
		</c-dialog>

		<c-dialog ref="edit" title="编辑模板" width="500">
			<c-form ref="editForm" unit-width="100%">
				<c-form-item label="模板名称" required>
					<c-input type="hidden" name="id"></c-input>
					<c-input name="template_name"></c-input>
				</c-form-item>
				<c-form-item label="纸张大小" required>
					<div class="flex" style="gap: 10px;">
						<c-select v-model="currentPaperSize" class="flex-grow" name="paper" :options="paperSize" :clear="false"></c-select>
						<div v-show="currentPaperSize == 'auto'" class="flex-center" style="min-width: 60%; gap: 5px;">
							<c-input type="number" decimal="1" :range="[1,100]" name="width" placeholder="宽度" append-text="cm" :clear="false"></c-input>
							<span>×</span>
							<c-input type="number" decimal="1" :range="[1,100]" name="height" placeholder="长度" append-text="cm" :clear="false"></c-input>
						</div>
					</div>
				</c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'templateManage',

		props: {
			workType: [Number, String],
			print: String,
			export: String
		},

		data() {
			return {
				currentTab: 1,
				htmlTempContent: '',
				templateList: [],
				currentPaperSize: ''
			}
		},

		computed: {
			...mapState(['paperSize']),

			tabList() {
				let list = [];
				if (this.print && this.auth(this.print)) {
					if (!['1','2','4','5','6','32','34','35','36','39', '40','42','43','45','47','51','53'].includes(this.workType.toString())) {
						list.push({'value': 1, 'name': '内置打印模板'});
					}
					if (!['9','16','26','27','50'].includes(this.workType.toString())) {
						list.push({'value': 2, 'name': 'Excel打印模板'});
					}
				}

				if (this.export && this.auth(this.export)) {
					list.push({'value': 3, 'name': 'Excel导出模板'});
				}
				return list;
			},

			templateCount() {
				return this.templateList.filter(item => item.is_sys_template == 1).length;
			},

			printReadmeUrl() {
				return {
					1: 'https://acnm59dijzgg.feishu.cn/docx/Qk3vdaw6toRqsKxRMnqc6IhznNb',//【销售订单】
					2: 'https://acnm59dijzgg.feishu.cn/docx/HefZdWwb2o0lsxxCinUcIKCKnzf',//【生产计划】
					3: 'https://acnm59dijzgg.feishu.cn/docx/OrmYdsYQ1o384IxtsFuceVY1nyd',//【工单】
					4: 'https://acnm59dijzgg.feishu.cn/docx/TFbqdiqL2ogO6Ex86r3cxxRZnBh',//【入库单】
					5: 'https://acnm59dijzgg.feishu.cn/docx/INAfdsHN8oXZpRxtswWcsv9Cn6d',//出库单
					6: 'https://acnm59dijzgg.feishu.cn/docx/HoUIdHGZAoB02txEBHBcFZwPnDd',//盘点单
					7:'https://acnm59dijzgg.feishu.cn/docx/VVN7dibZnoQiVuxCD47cgOuOnff', //【产品信息】
					13: 'https://acnm59dijzgg.feishu.cn/docx/N8DEdfnxtoh180xzpPtcULSRn7f', //【任务】
					14: 'https://acnm59dijzgg.feishu.cn/docx/OljCdnurVowD5PxDOOgc87YYnAc',//【报工】
					29: 'https://acnm59dijzgg.feishu.cn/docx/BOZGdG7zJoEc5cxDlNUcExPnnEh',//【委外单】
					32: 'https://acnm59dijzgg.feishu.cn/docx/MeDQdOFr8ozAZpxOkYdcQElynWg',//【发货单】
					33: 'https://acnm59dijzgg.feishu.cn/docx/UkPcdCEoIoqRqoxLyJMcdcsPnef',//【发货单明细】
					34: 'https://acnm59dijzgg.feishu.cn/docx/LLUjdUCGYoLieMxuw7bcwftxnTe',//【装配工单】
					35: 'https://acnm59dijzgg.feishu.cn/docx/NjD6d0bzJoXyEdxB37qc78wAnNc',//委外动态
					36: 'https://acnm59dijzgg.feishu.cn/docx/CdCNdF9wjoujdDx7kbhc1hR8nqh',//委外结算单
					39: 'https://acnm59dijzgg.feishu.cn/docx/MgIPd6IIcorkmaxPZzEcqtMGnFf',//采购单
                    40: 'https://acnm59dijzgg.feishu.cn/docx/YXb1d8ufQooiaCxs0NEcn6Eonng',//采购单明细
					41: 'https://acnm59dijzgg.feishu.cn/docx/HqYvdlITyoiegOxoYBacJd9FnY0',//销售订单明细列表
					42: 'https://acnm59dijzgg.feishu.cn/docx/OFgodlXQaogG12xaVRWc7N5mnic',//报工检验
					43: 'https://acnm59dijzgg.feishu.cn/docx/TjeqdrNQOoRfRzxSdfucw96NnWh',//报工检验处理
					45: 'https://acnm59dijzgg.feishu.cn/docx/Lp2hdkgkWoqFGfxfWQmc2islnxf',//生产入库检
					47: 'https://acnm59dijzgg.feishu.cn/docx/MDvIdz8nUozsyvxidh7c4Nrjnhb'//生产入库检验处理
                }[this.workType];
			},

			exportReadmeUrl() {
				return {
					1: 'https://acnm59dijzgg.feishu.cn/docx/LWLfdloIXoSZZRxVYaXc8PQon3f',//销售订单
					2: 'https://acnm59dijzgg.feishu.cn/docx/PVvrdqzIhoH57zxpYZdcx5wNnjb',//生产计划
					3: 'https://acnm59dijzgg.feishu.cn/docx/BhMAdpuVkowyVNxcVvUcOchNnzg',//工单
					4: 'https://acnm59dijzgg.feishu.cn/docx/UHApd4KPHoTxUHxfd49cc2kInBA',//入库单
					5: 'https://acnm59dijzgg.feishu.cn/docx/YWqId6mjuobK6VxD3Tzciq1Hnrd',//出库单
					6: 'https://acnm59dijzgg.feishu.cn/docx/GtP5dEYqEoXAprxky4rczzkknQc',//盘点单
					7: 'https://acnm59dijzgg.feishu.cn/docx/XtFldabnOozx0XxY61IcABwEnRc', //产品信息
					9: 'https://acnm59dijzgg.feishu.cn/docx/QSUCdCf1coY1KfxMwJCcO9IYnfd',//工序
					10: 'https://acnm59dijzgg.feishu.cn/docx/VdsddBNSToMD7Cx3DSMcouAknSd',//工艺路线
					11: 'https://acnm59dijzgg.feishu.cn/docx/CT33ddbc8omrqlxveRJcjsGVnDb',//客户
					12: 'https://acnm59dijzgg.feishu.cn/docx/Michd4AoiogrNmxcat0cxLYhnXd',//供应商
					13: 'https://acnm59dijzgg.feishu.cn/docx/ZL5MdaInloAXLuxTqplcJ6zmnod',//任务
					14: 'https://acnm59dijzgg.feishu.cn/docx/QUfrduoqno8erCxjHprclo8nn9b',//报工
					15: 'https://acnm59dijzgg.feishu.cn/docx/Qb0IdlAU7oV9zixk7vscrNy7ncf',//物料清单
					16: 'https://acnm59dijzgg.feishu.cn/docx/G5Aldz4C7ovvxSxpFQLcyibDnfb',//库存收发明细
					17: 'https://acnm59dijzgg.feishu.cn/docx/T8cyd0AzIomNV3xqrurcanRRncw',//库存余额
					18: 'https://acnm59dijzgg.feishu.cn/docx/Hbdydym7iocuD2xfZkhccemAnQh',//库存余额明细
					19: 'https://acnm59dijzgg.feishu.cn/docx/U235dBfPAo2ynhxn0YdcDGIbnsh',//进销存汇总
					25: 'https://acnm59dijzgg.feishu.cn/docx/NPqkdcTERoHtLExzY0ucDSQlnOc',//库存变更记录
					29: 'https://acnm59dijzgg.feishu.cn/docx/Atckd7AAXo5MPGxXbWdc1YVYnEg',//委外单
					32: 'https://acnm59dijzgg.feishu.cn/docx/GgdPdGtCAo9GOGxJCHicTIFNn4e',//发货单
					33: 'https://acnm59dijzgg.feishu.cn/docx/TRYTdRtNToYVybx0jiBcQlVanWD',//发货单明细列表
					34: 'https://acnm59dijzgg.feishu.cn/docx/ChjwdGo1DosJaMxGvm5c7LvNng8',//装配工单
					35: 'https://acnm59dijzgg.feishu.cn/docx/QL7vdA5bRoEVWyxeY9bc2IaZnE6',//委外动态
					36: 'https://acnm59dijzgg.feishu.cn/docx/Oqn1dG0tioCjX4xJuxAcBSKqnGc',//委外结算单
					39: 'https://acnm59dijzgg.feishu.cn/docx/AOkrd2U2Roz4Qqxf05pcgE3Zn4c',//采购单
                    40: 'https://acnm59dijzgg.feishu.cn/docx/J8NgdeQUooM5qFxFmVjcaKIwnhf',//采购单明细
					41: 'https://acnm59dijzgg.feishu.cn/docx/HryCd04eFomFInxtSydcxkGwnGb',//销售订单明细
					42: 'https://acnm59dijzgg.feishu.cn/docx/Qz9ydBT17oEaqFxbydlcQacwnog',//报工检验
					43: 'https://acnm59dijzgg.feishu.cn/docx/ECuWdt5eooq4T8xQuJgcHfvLnPb',//报工检验处理
					45: 'https://acnm59dijzgg.feishu.cn/docx/S686dne0WoovyTxxvmvcMK7mnTc',//生产入库检
					47: 'https://acnm59dijzgg.feishu.cn/docx/VBcpdPxDjoeIBuxQf5HcnJp7nlb'//生产入库检验处理
				}[this.workType];
			}
		},

		watch: {
			currentPaperSize(val) {
				if (!val || val == 'auto') {
					this.$refs.editForm.set({
						width: '',
						height: ''
					});
				} else {
					let [width, height] = val.split('x');
					this.$refs.editForm.set({
						width,
						height
					});
				}
			}
		},
		
		methods: {
			open() {
				this.$refs.tabList.changeIndex(0);
				this.$refs.dialog.open({
					title: `【${this.getSys().crumbList[this.getSys().crumbList.length - 1]}】模板管理`
				});
			},

			tabHandle(tab) {
				this.currentTab = tab.value;
				this.templateList = [];
				this.loadTemplate();
			},

			loadTemplate() {
				this.htmlTempContent = '';
				this.request({
					url: '/export/template/list',
					data: {
						template_type: this.currentTab,
						work_type: this.workType
					},
					success: data => {
						if (this.currentTab == 1) {
							data.forEach(item => {
								let [width, height] = JSON.parse(item.template_config).paper.split('x');
								item.width = width;
								item.height = height;
							})
						}
						this.templateList = data;
					}
				});
			},

			async clickHandle({data}) {
				this.htmlTempContent = await this.templatePreview(data.template_content, true);
			},

			editHandle(data = {}, copy) {
				this.globalDialog('printTemplateEdit', {
					data: Object.assign(data, {
						copy,
						workType: this.workType
					})
				}, this.loadTemplate)
			},

			uploadHandle() {
				if (this.templateCount >= 50) {
					this.$message({
						message: '最多只能上传50个Excel模板'
					});
					return;
				}

				this.$upload({
					type: 'xlsx',
					loading: true,
					success: data => {
						this.request({
							url:'/export/template/add',
							data: {
								template_type: this.currentTab,
								work_type: this.workType,
								template_url: data[0].path
							},
							success: () => {
								this.loadTemplate();
							}
						});
					}
				});
			},

			downloadHandle(data) {
				var index = data.template_url.lastIndexOf('.');
				var fineName = data.template_name + data.template_url.substring(index,data.template_url.length);
				this.download({
					signFree: data.is_sys_template == 2,
					fileName:fineName,
					url: data.template_url,
					loading: {
						message: '文件下载中...'
					}
				});
			},

			paperHandle(data) {
				this.$refs.edit.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.editForm.submit({
							url: '/export/template/excel/edit',
							rule: {
								template_name: '请填写模板名称',
								paper: '请选择纸张大小',
								width: '请填写纸张大小',
								height: '请填写纸张大小'
							},
							success: () => {
								next();
								this.$message({
									message: '提交成功'
								});
								this.loadTemplate();
							}
						})
					}
				});
				let paperSize = this.paperSize.find(item => item.value == `${data.width}x${data.height}`);
				this.currentPaperSize = paperSize ? paperSize.value : 'auto'
				this.$nextTick(() => {
					this.$refs.editForm.set(data);
				});
			},

			deleteHandle(data) {
				this.$confirm({
					message: '确定要删除该模板吗？',
					resolve: () => {
						this.request({
							url: '/export/template/remove',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '模板已删除'
								});
								this.loadTemplate();
							}
						})
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.preview {
		position: relative;
		box-sizing: border-box;
		min-width: 340px;
		border-left: 1px solid var(--table-border);
		overflow: auto;
		background: #F8F8F8;

		&-title {
			position: sticky;
			left: 0;
			top: 0;
			line-height: 44px;
			font-size: 16px;
			font-weight: bold;
			text-align: center;	
			background: #F8F8F8;
		}

		&-content {
			display: inline-block;
		}

		>>> .print-page {
			box-sizing: border-box;
			margin: 0 10px 10px;
			overflow: hidden;
			font-size: 10pt;
			background: #fff;
			
			table {
				width: 100%;
				max-width: 100%;
				border: .2mm solid #000;

				td {
					vertical-align: middle;
					border: .2mm solid #000;
					padding: 1.5mm;
					word-break: break-all;

					img {
						vertical-align: middle;
					}
				}
			}
		}
	}

	.import-steps {
		padding: 10px 20px;
		margin: 10px;
		background-color: #F8F8F8;

		p {
			padding: 4px 0;
			line-height: 20px;
			color: #666;
		}
	}
</style>